import React from 'react';

export default function Logo({ className='' }){
    return (
        <svg className={"site-logo" + (className ? " " + className : "")} version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 2058 536" xmlSpace="preserve">
            <polygon className="letter let-m" points="508,509.8 27.6,509.8 27.6,27.1 268.9,186.5 508,27.1 "/>
            <polygon className="letter let-m2" points="1446.2,509.8 965.7,509.8 965.7,27.1 1207,186.5 1446.2,27.1 "/>
            <polygon className="letter let-a" points="1792.8,32.4 1555.3,509.7 2030.4,509.7 "/>
            <circle className="circle" cx="737.3" cy="159.3" r="129.3"/>
        </svg>
    )
}